import Vue from 'vue'
import VueRouter from 'vue-router'
import tab from '../views/tab.vue'
import index from '../views/index.vue'
import dynamic from '../views/dynamic.vue'
import mechanism from '../views/mechanism.vue'
import activity from '../views/activity.vue'
import activityDetail from '../views/activityDetail.vue'
import chance from '../views/chance.vue'
import videoList from '../views/videoList.vue'
import joinCBH from '../views/joinCBH.vue'
import publication from '../views/publication.vue'
import chanceList from '../views/chanceList.vue'
import carbon from '../views/carbon.vue'
import someAction from '../views/someAction.vue'
import climate from '../views/climate.vue'
import addCbh from '../views/addCbh.vue'
import newsDetail from '../views/newsDetail.vue'
import dynamicList from '../views/dynamicList.vue'
import fuel from '../views/fuel.vue'
import cases from '../views/cases.vue'
import projectDetailOld from '../views/publication-old.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: tab,
    children:[
      {
        path: '/',
        name: 'index',
        meta: {
          auth : true,
          title: '首页'
        },
        component: index
      },
      {
        path: '/news',
        name: 'news',
        meta: {
          auth : true,
          title: '新闻动态'
        },
        component: dynamic
      },
      {
        path: '/cases',
        name: 'cases',
        meta: {
          auth : true,
          title: '案例'
        },
        component: cases
      },
      {
        path: '/mechanism',
        name: 'mechanism',
        meta: {
          auth : true,
          title: '新闻动态'
        },
        component: mechanism
      },
      {
        path: '/activity',
        name: 'activity',
        meta: {
          auth : true,
          title: '活动'
        },
        component: activity
      },
      {
        path: '/activityDetail',
        name: 'activityDetail',
        meta: {
          auth : true,
          title: '活动'
        },
        component: activityDetail
      },
      {
        path: '/chance',
        name: 'chance',
        meta: {
          auth : true,
          title: '项目详情'
        },
        component: chance
      },
      {
        path: '/videoList',
        name: 'videoList',
        meta: {
          auth : true,
          title: '视频'
        },
        component: videoList
      },
      // {
      //   path: '/joinCBH',
      //   name: 'joinCBH',
      //   meta: {
      //     auth : true,
      //     title: '加入CBH'
      //   },
      //   component: joinCBH
      // },
      {
        path:'/projectDetail',
        name: 'newsDetail',
        meta: {
          auth : true,
          title: '详情'
        },
        component: newsDetail
      },
      {
        path:'/projectDetailOld',
        name: 'projectDetailOld',
        meta: {
          auth : true,
          title: '详情'
        },
        component: projectDetailOld
      },
      {
        path: '/publication',
        name: 'publication',
        meta: {
          auth : true,
          title: '出版物'
        },
        component: publication
      },
      {
        path: '/chanceList',
        name: 'chanceList',
        meta: {
          auth : true,
          title: '项目介绍'
        },
        component: chanceList
      },
      {
        path: '/sbti',
        name: 'sbti',
        meta: {
          auth : true,
          title: '科学碳目标'
        },
        component: carbon
      },
      {
        path: '/RE',
        name: 'RE',
        meta: {
          auth : true,
          title: '绿色电力需求行动'
        },
        component: someAction
      },
      {
        path: '/climatesolver',
        name: 'climatesolver',
        meta: {
          auth : true,
          title: '气候创行者'
        },
        component: climate
      },
      {
        path: '/joinCBH',
        name: 'joinCBH',
        meta: {
          auth : true,
          title: '加入CBH'
        },
        component: addCbh
      },
      {
        path: '/dynamicList',
        name: 'dynamicList',
        meta: {
          auth : true,
          title: '新闻列表页'
        },
        component: dynamicList
      },
      {
        path: '/fuel',
        name: 'fuel',
        meta: {
          auth : true,
          title: '新闻列表页'
        },
        component: fuel
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
